(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-footer-pre-whatsapp-icon-fix"]) return;
  try {
    
(function(){
  var media=window.matchMedia('(min-width:768px)');
  var sync=function(root){root.querySelectorAll('[data-fm-footer-group]').forEach(function(group){group.open=media.matches})};
  var init=function(){sync(document)};
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  if(media.addEventListener){media.addEventListener('change',init)}else{media.addListener(init)}
  document.addEventListener('shopify:section:load',function(event){sync(event.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-footer-pre-whatsapp-inline-svg"]) return;
  try {
    
(function(){
  var media=window.matchMedia('(min-width:768px)');
  var sync=function(root){root.querySelectorAll('[data-fm-footer-group]').forEach(function(group){group.open=media.matches})};
  var init=function(){sync(document)};
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  if(media.addEventListener){media.addEventListener('change',init)}else{media.addListener(init)}
  document.addEventListener('shopify:section:load',function(event){sync(event.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-footer"]) return;
  try {
    
(function(){
  var media=window.matchMedia('(min-width:768px)');
  var sync=function(root){root.querySelectorAll('[data-fm-footer-group]').forEach(function(group){group.open=media.matches})};
  var init=function(){sync(document)};
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  if(media.addEventListener){media.addEventListener('change',init)}else{media.addListener(init)}
  document.addEventListener('shopify:section:load',function(event){sync(event.target)})
})();

  } catch(e) { console.error(e); }
})();
})();
